module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-logs-container"
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    class: {
      disabled: _vm.loading
    }
  }, [_c('h1', [_vm._v("Ändringsloggar")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "logs-filters"
  }, [_c('div', {
    staticClass: "filter-group"
  }, [_c('label', {
    attrs: {
      "for": "filter-user"
    }
  }, [_vm._v("Användare")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterUser),
      expression: "filterUser"
    }],
    attrs: {
      "id": "filter-user"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterUser = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.handleFilterChange]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Alla användare")]), _vm._v(" "), _vm._l((_vm.distinctEmails), function(user) {
    return _c('option', {
      key: user,
      domProps: {
        "value": user
      }
    }, [_vm._v("\n            " + _vm._s(user) + "\n          ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "filter-group"
  }, [_c('label', {
    attrs: {
      "for": "filter-action"
    }
  }, [_vm._v("Händelse")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterAction),
      expression: "filterAction"
    }],
    attrs: {
      "id": "filter-action"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterAction = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.handleFilterChange]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Alla händelser")]), _vm._v(" "), _vm._l((_vm.distinctActions), function(action) {
    return _c('option', {
      key: action,
      domProps: {
        "value": action
      }
    }, [_vm._v("\n            " + _vm._s(_vm.formatAction(action)) + "\n          ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "filter-group text-search"
  }, [_c('label', {
    attrs: {
      "for": "filter-search"
    }
  }, [_vm._v("Fritextsök (detaljer)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    attrs: {
      "id": "filter-search",
      "type": "text",
      "placeholder": "Sök i detaljer..."
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }, _vm.debounceSearch]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "logs-list-section"
  }, [_c('table', {
    staticClass: "logs-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.logs), function(log) {
    return _c('tr', {
      key: log.id
    }, [_c('td', {
      staticClass: "time-cell"
    }, [_vm._v(_vm._s(_vm.formatDate(log.created_at)))]), _vm._v(" "), _c('td', {
      staticClass: "email-cell"
    }, [_vm._v(_vm._s(log.email))]), _vm._v(" "), _c('td', [_c('span', {
      class: 'action-badge ' + log.action
    }, [_vm._v("\n                " + _vm._s(_vm.formatAction(log.action)) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "details-cell"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatDetails(log.action, log.details))
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "ip-cell"
    }, [_vm._v(_vm._s(log.ip_address || '-'))])])
  }), _vm._v(" "), (_vm.logs.length === 0) ? _c('tr', [_c('td', {
    staticClass: "empty-cell",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Inga loggar hittades.")])]) : _vm._e()], 2)])]), _vm._v(" "), (_vm.lastPage > 1) ? _c('div', {
    staticClass: "pagination-section"
  }, [_c('button', {
    staticClass: "btn-nav",
    attrs: {
      "disabled": _vm.currentPage === 1
    },
    on: {
      "click": function($event) {
        return _vm.changePage(_vm.currentPage - 1)
      }
    }
  }, [_vm._v("\n        Föregående\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "pagination-info"
  }, [_vm._v("\n        Sida " + _vm._s(_vm.currentPage) + " av " + _vm._s(_vm.lastPage) + " (totalt " + _vm._s(_vm.totalLogs) + " rader)\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn-nav",
    attrs: {
      "disabled": _vm.currentPage === _vm.lastPage
    },
    on: {
      "click": function($event) {
        return _vm.changePage(_vm.currentPage + 1)
      }
    }
  }, [_vm._v("\n        Nästa\n      ")])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Tid")]), _vm._v(" "), _c('th', [_vm._v("Användare")]), _vm._v(" "), _c('th', [_vm._v("Händelse")]), _vm._v(" "), _c('th', [_vm._v("Detaljer")]), _vm._v(" "), _c('th', [_vm._v("IP")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a0ec3ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Logs.vue
// module id = 1007
// module chunks = 0